import { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL;
const ShopContext = createContext(null);

export function ShopProvider({ children }) {
  const [salesEnabled, setSalesEnabled] = useState(false);
  const [ready, setReady] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const res = await axios.get(`${API_URL}/api/shop`);
      setSalesEnabled(!!res.data?.sales_enabled);
    } catch {
      /* tiene l'ultimo valore noto; al primo caricamento resta disattivata */
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => {
    refresh();
    const onVisible = () => {
      if (document.visibilityState === "visible") refresh();
    };
    document.addEventListener("visibilitychange", onVisible);
    return () => document.removeEventListener("visibilitychange", onVisible);
  }, [refresh]);

  return (
    <ShopContext.Provider value={{ salesEnabled, ready, refresh }}>
      {children}
    </ShopContext.Provider>
  );
}

export function useShop() {
  const ctx = useContext(ShopContext);
  if (!ctx) throw new Error("useShop must be used within ShopProvider");
  return ctx;
}
